export default __webpack_public_path__ + "static/media/app-store.26c6a64d.svg";